import { render, staticRenderFns } from "./StockAdjustmentItemsDocuments.html?vue&type=template&id=7865b67d&scoped=true&external"
import script from "./StockAdjustmentItemsDocuments.js?vue&type=script&lang=js&external"
export * from "./StockAdjustmentItemsDocuments.js?vue&type=script&lang=js&external"
import style0 from "./StockAdjustmentItemsDocuments.scss?vue&type=style&index=0&id=7865b67d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7865b67d",
  null
  
)

export default component.exports